module.exports = __webpack_public_path__ + "img/dy_5@2x.52b24f3d.png";